export const UserAPI = {};

const SLICE = 'user';


UserAPI.create = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/user`,
    method:   'POST',
    data:     data,
    slice:     SLICE,
    action:    'create',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

UserAPI.delete = (ids, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/user`,
    method:    'DELETE',
    data:      {ids},
    slice:     SLICE,
    action:    'delete',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

UserAPI.update = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/user`,
    method:   'PUT',
    data:     data,
    slice:     SLICE,
    action:    'update',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

UserAPI.list = (data, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/users`,
    method:    'GET',
    data:      data,
    slice:     SLICE,
    action:    'list',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

UserAPI.item = (id, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/user`,
    method:    'GET',
    data:      {id},
    slice:     SLICE,
    action:    'item',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

UserAPI.search = (name, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/users`,
    method:    'POST',
    data:      {name},
    slice:     SLICE,
    action:    'search',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

UserAPI.passwd = (data, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/user/passwd`,
    method:    'POST',
    data:      data,
    slice:     SLICE,
    action:    'passwd',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

